import src from "IMAGE";
export default { src, width: 580, height: 233, blurWidth: 0, blurHeight: 0};
